<form [formGroup]="stockForm" (ngSubmit)="addToList()" class="flex flex-col gap-8">
  <div class="rounded-2xl border border-gray-100 bg-white p-8 shadow-sm">
    <app-stock-information
      [type]="type()"
      [productId]="productId()"
      [suppliers]="suppliers()"
      [productsAutocomplete]="productsAutocomplete()"
      [showAutocomplete]="showProductAutocomplete()"
      (searchProduct)="onProductSearch($event)"
      (productSelected)="selectProduct($event)"
      (closeAutocomplete)="showProductAutocomplete.set(false)"></app-stock-information>

    <div class="my-8 border-t border-gray-50"></div>

    <app-product-prices [type]="type()" [showZone]="false" />

    <div class="mt-8 flex justify-end">
      <button
        type="submit"
        class="bgTabsColor cursor-pointer rounded-lg px-12 py-3 font-bold text-white shadow-md transition">
        <span i18n="@@stock.button.addToList">Add to List</span>
      </button>
    </div>
  </div>
</form>

@if (showSuccess()) {
  <app-successful-notification
    type="success"
    i18n-title="@@stock.success.created"
    title="Stock has been added successfully." />
}

@if (getFormValidationError()) {
  <div class="mt-6">
    <app-error [apiError]="getFormValidationError()" />
  </div>
} @else if (pageError()) {
  <div class="mt-6">
    <app-error [apiError]="pageError() ?? ''" />
  </div>
}

@if (temporaryStockList().length > 0) {
  <app-stock-temporary-table
    [list]="temporaryStockList()"
    (onEdit)="editItem($event)"
    (onRemove)="removeItem($event)"
    (onSubmit)="submitAll()"
    (onReset)="resetAll()"></app-stock-temporary-table>
} @else {
  <div class="mt-10 rounded-2xl border-2 border-dashed border-gray-200 bg-gray-50 p-12 text-center">
    <p class="text-gray-500" i18n="@@stock.list.empty">No items added yet. Fill the form above to add stock items.</p>
  </div>
}
